module.exports = __webpack_public_path__ + "img/desayuno.2ec421e7.png";